import { ADD_RELATIONS, APPEND_RELATIONS, UPDATE_USED_RELATION } from '../actionsList';



const initialInfo = {
    relations: []
};
const relationsReducer = (state = initialInfo, action) => {

switch (action.type) {

    case APPEND_RELATIONS: {
        let relations = state.relations

        if (!relations) {
            relations = []
        }

        action.relations.map((relation) => {
            let found = false
            relations.map((oneRelation) => {
                if (relation._id == oneRelation._id) {
                    found = true
                }
            })
            if (!found) {
                relations.push(relation)
            }
        })

        // console.log(key)
        // console.log(list)

        return {
            ...state,
            relations: relations,
        }

    }
    case ADD_RELATIONS: {
        let relations = []

        action.relations.map((relation) => {
            let found = false
            relations.map((oneRelation) => {
                if (relation._id == oneRelation._id) {
                    found = true
                }
            })
            if (!found) {
                relations.push(relation)
            }
        })
        return {
            ...state,
            relations: relations,
        }

    }
    case UPDATE_USED_RELATION: {
        let relations = state.relations
        let now = new Date()
        if (!relations) {
            relations = []
        }
        action.relations.map((relation) => {
            relations.map((oneRelation, index) => {
                // console.log('oneRelation._id',oneRelation._id)
                // console.log('relation._id',relation._id)
                if (relation?._id == oneRelation?._id) {
                    // console.log('found rudesss')
                    relations[index].rDate = now
                }
            })
        })
        relations.sort((a, b) => {
            if (!a.rDate && !b.rDate) {
                return 0;
            }
            if (!a.rDate) {
                return 1;
            }
            if (!b.rDate) {
                return -1;
            }
            return new Date(b.rDate).getTime() - new Date(a.rDate).getTime();
        })
        return {
            ...state,
            relations: relations,
        }
    }
    default:
        return state;
}
}
export default relationsReducer;